'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#0744A7" }),
      /* @__PURE__ */ jsx("path", { d: "M28.0002 8H0.00016276V10.6667H28.0002V8Z", fill: "#FCC747" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.3335 16.3334L6.30344 17.8369L6.35385 16.0151L4.63677 16.626L5.7484 15.1817L4.00016 14.6667L5.7484 14.1517L4.63677 12.7074L6.35385 13.3183L6.30344 11.4965L7.3335 13L8.36355 11.4965L8.31314 13.3183L10.0302 12.7074L8.91859 14.1517L10.6668 14.6667L8.91859 15.1817L10.0302 16.626L8.31314 16.0151L8.36355 17.8369L7.3335 16.3334Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagNrAsset = forwardRef(FlagNrAsset);

export { VpFlagNrAsset as default };
